<div class="pnc-detail">
    <ng-container #stickyHeaderContainer></ng-container>
    <ng-container #headerContainer></ng-container>
    <ng-container #bodyContainer></ng-container>
</div>
<footer>
    <ng-container #footerContainer></ng-container>
</footer>
